<template>
  <div>
    <v-text-field :label="label" v-model="foreignFieldValue" @click="presentCombobox()"></v-text-field>

    <div class="text-center">
      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title
            :style="{color:getSecondaryColor,'background-color':getThemeColor}"
          >Select {{label}}</v-card-title>

          <v-select class="mx-10" :items="rowData" :label="label" v-model="selectedRowValue"></v-select>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="dialog = false">Cancel</v-btn>
            <v-btn :color="getThemeColor" text @click="submitSelection()">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  props: ["label", "foreignFieldValue", "table"],
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    }
  },
  data() {
    return {
      rowData: [],
      dialog: false,
      selectedRowValue: null
    };
  },
  methods: {
    presentCombobox() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-foreign-key-data",
          { table: this.table, column: this.column },
          this.getAccessToken
        )
        .then(rowData => {
          this.rowData = [];
          rowData.forEach(row => {
            this.rowData.push({
              text: row.name,
              value: `${row.id} +! ${row.name}`
            });
          });

          this.$store.commit("setLoader", false);
          this.dialog = true;
        });
    },
    submitSelection() {
      const vals = this.selectedRowValue.split("+!");
      this.$emit("field-selected", vals);
      this.dialog = false;
    }
  }
};
</script>

<style>
</style>